import { CatalogMetadata } from "./catalog-metadata.model";
import { CatalogScope } from "./catalog-scope.enum";

export class FormationCementCatalog {
  public constructor(init?: Partial<FormationCementCatalog>) {
    Object.assign(this, init);
    this.metadata = init && init.metadata ? new CatalogMetadata(init.metadata) : null;
  }

  id: string;
  name: string;
  density: number;
  specificHeatCapacity: number;
  thermalConductivity: number;
  youngsModulus: number;
  poissonsRatio: number;
  thermalExpansionCoefficient: number;
  discriminator: string;
  isLocked: boolean;
  metadata: CatalogMetadata;
  scope: CatalogScope;
}
